import { EntitiesType } from "api/SirenEntityType"
import resolveComponents from "components/resolveComponents"

const Entities = ({ entities, ...props }) => resolveComponents(entities, props)
Entities.propTypes = {
  entities: EntitiesType,
}
export default Entities
